import { ReactNode } from 'react';
import styles from './DialogFooter.module.scss';

interface Props {
  children: ReactNode;
}

export function DialogFooter(props: Props) {
  return <div className={styles['dialog-footer']}>{props.children}</div>;
}
